import { render, staticRenderFns } from "./CartStep2.vue?vue&type=template&id=b4fb367a&scoped=true&"
import script from "./CartStep2.vue?vue&type=script&lang=js&"
export * from "./CartStep2.vue?vue&type=script&lang=js&"
import style0 from "./CartStep2.vue?vue&type=style&index=0&id=b4fb367a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fb367a",
  null
  
)

export default component.exports